import { Charts } from './Charts';
import FamiliesChartsDataProvider from './contexts/FamiliesChartsDataContext';

const FamiliesWrapper = () => {
    return (
        <FamiliesChartsDataProvider>
            <Charts />
        </FamiliesChartsDataProvider>
    );
};

export default FamiliesWrapper;
